import React, { useEffect, useState } from 'react'
import { Redirect } from 'react-router-dom'
import Sort from "../../assets/images/llantas/table/sort.svg";
import SortAsc from "../../assets/images/llantas/table/sort-asc.svg";
import SortDesc from "../../assets/images/llantas/table/sort-desc.svg";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import UpIcon from '@material-ui/icons/KeyboardArrowUp';
import Loading from '../ui/Loading.js'
import {
	CircularProgress,
	Table,
	TableContainer,
	TableHead,
	TableRow,
	TableBody,
	TablePagination,
} from '@material-ui/core';
import { StyledTableCell, StyledTooltip, rowsPerPage } from '../../commons/utils/TableStyles'
import * as Utils from '../../commons/utils/Utils';
import { FormattedMessage, useIntl } from 'react-intl';
import FormularioRecurrenciaGridRow from './FormularioRecurrenciaGridRow';
import FormularioRecurrenciaGridFilters from './FormularioRecurrenciaGridFilters';
import Security from '../../commons/security/Security'
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import * as ESTADOS from '../../commons/constants/formularioRecurrenciaEstado.js';
import backendStrings from '../../lang/backendStrings.js';

const PAGINATION_INIT = {
	page: 0,
	count: 0,
	perPage: 10,
}

const FILTER_QUERY_INIT = {
	centroCosto: '',
	estado: '',
	tipoFormulario: '',
	entidad: '',
	periodoInicio: '',
	periodoFin: '',
	dashboard: '',
	showInactivos: false,
	transportadora: '',
}

const SORT_QUERY_INIT = {
	tipoFormulario: '',
	fechaVencimiento: ''
}

const COLUMNS_ENABLED_INIT = {
	transportadora: false
}

const getStorage = () =>{
	let storage = JSON.parse(window.localStorage.getItem('FormularioRecurrenciaGridFilter'));
	if(storage && storage.activo){
		return true
	}
	else{
		return false
	}
}

const FormularioRecurrenciaGrid = (props) => {
	const intl = useIntl();
	const filterEntidad = (new URLSearchParams(props.location.search)).get('entidad')

	const [formularioRecurrencias, setFormularioRecurrencias] = useState([]);
	const [loading, setLoading] = useState(false);
	const [pagination, setPagination] = useState({ ...PAGINATION_INIT });
	const [paginationCount, setPaginationCount] = useState(0);
	const [filterQuery, setFilterQuery] = useState(null);
	const [filterQueryLast, setFilterQueryLast] = useState(null);
	const [sortQuery, setSortQuery] = useState({ ...SORT_QUERY_INIT });
	const [searchActive, setSearchActive] = useState(false);
	const [columnsEnabled, setColumnsEnabled] = useState({ ...COLUMNS_ENABLED_INIT });
	const [dropdownActive, setDropdownActive] = useState(false);
	const [resetFilterInputs, setResetFilterInputs] = useState(false);
	const [redirectTo, setRedirectTo] = useState(null);
	const [filterResetInputs,setFilterResetInputs] = useState(false);
	const [summaryAlerts, setSummaryAlerts] = useState(null);
	const [persisteFiltros,setPersisteFiltros] = useState(getStorage());
	const backColor = 'white';
	const selectedColor = "#e2e2e2";

	useEffect(() => {
		if (
			ConfigBusiness.get("checklist_recurrencia.habilitado") === 'true' && Security.hasPermission('FORMULARIO_RECURRENCIA_LISTAR')
		) {
		  filterQuery && fetchControles();
		  setLoading(true);
		  filterQuery && fetchFormularioRecurrencias();
		  configColumns();
		} else {
			setRedirectTo('/error');
		}
	}, [pagination, sortQuery, filterQuery])

	const fetchFormularioRecurrencias = () => {
		Utils.getData(`/formulario-recurrencias${getQuery()}`).then((data) => {
			setFormularioRecurrencias(data.formularioRecurrencias);
			setLoading(false);
			setPaginationCount(data.pagination.count);
			setLoading(false);
			setFilterQueryLast(filterQuery);
		}).catch((error) => {
			console.log(error);
			setLoading(false);
		})
	}

	const fetchControles = () => {
		Utils.getData(`/formulario-recurrencias/controles/alarmas${getQuery()}`).then((data) => {
			setSummaryAlerts(data);
		}).catch((error) => {
			console.log(error);
		})
	}

	const configColumns = () => {
		let aux = {...columnsEnabled};
		aux.transportadora = ConfigBusiness.get('moviles.transportadora.grilla') === 'true';
		setColumnsEnabled(aux);
	}

	const handleFilterDashboard = (filter) => {
	  switch (filter) {
		case 'vencidas':
		  filterQuery.dashboard = 'vencidas';
		  break;
		case 'pendientes':
		  filterQuery.dashboard = 'pendientes';
		  break;
		case 'realizadas':
		  filterQuery.dashboard = 'realizadas';
		  break;
		case 'total':
		  filterQuery.dashboard = 'total';
		  break;
		default:
		  break;
	  }
	  setLoading(true);
	  fetchFormularioRecurrencias();
	}

	const getQuery = () => {
		let query = "?page=" + pagination.page
		query += "&perPage=" + pagination.perPage
  
		// Filtrado
		query += "&centroCosto=" + filterQuery.centroCosto
		query += "&estado=" + filterQuery.estado
		query += "&tipoFormulario=" + filterQuery.tipoFormulario
		query += "&entidad=" + filterQuery.entidad
		query += "&showInactivos=" + filterQuery.showInactivos
		query += "&periodoInicio=" + filterQuery.periodoInicio
		query += "&periodoFin=" + filterQuery.periodoFin
		query += "&dashboard=" + filterQuery.dashboard
		query += "&transportadora=" + filterQuery.transportadora
		// Ordenamiento
		query += '&tipoFormularioSort=' + sortQuery.tipoFormulario
		query += '&fechaVencimientoSort=' + sortQuery.fechaVencimiento

		return query
	}

	const handlePageChange = (event, newPage) => {
		setPagination({ ...pagination, page: newPage });
	}

	const handleRowsPerPageChange = (event) => {
		setPagination({ ...pagination, perPage: parseInt(event.target.value, 10), page: 0 });
	}

	const handleSort = (key) => {
		let query = { ...sortQuery }
		let orden = (sortQuery[key] == '' || sortQuery[key] === 'desc') ? 'asc' : 'desc';
		query['tipoFormulario'] = '';
		query['fechaVencimiento'] = '';
		query[key] = orden;
		setSortQuery(query);
	}

	const handleFilterReset = () => {
		setPagination(PAGINATION_INIT);
		setFilterQuery(FILTER_QUERY_INIT);
		setSortQuery(SORT_QUERY_INIT);
		setDropdownActive(false);
		setSearchActive(false);
		setResetFilterInputs(true);
		setPersisteFiltros(false)
	};

	const handleFilterChange = () => {
		setPagination(prevState => ({ ...prevState, page: 0 }));
	}
	
	return (
	<>
	  {redirectTo && <Redirect push to={redirectTo} />}
	  {loading && <Loading />}
	  {summaryAlerts ?
		<section className="combustiblesWidget">
		  <div className="row">
			{summaryAlerts.map((alert, index)=>{
				return(
					<div key={index} className={"col-xl-3 col-lg-6 col-12"} style={{ paddingRight: "0.5rem", paddingLeft: "0.5rem" }}>
						<div className="card pull-up">  
							<div className="card-content" style={{ backgroundColor: filterQuery.dashboard === alert.filter ? selectedColor : alert.backColor, borderRadius: ".45rem",cursor:alert.cursor }} >
								<div
									style={{padding: "15px"}} className="card-body"  onClick={alert.cursor == 'pointer' ? (e) => handleFilterDashboard(alert.filter) : null}
									>
									<div className="text-right">
										<h5 className="text-muted text-bold-500"><FormattedMessage {...(backendStrings[alert.description] ? backendStrings[alert.description] : backendStrings['errors.default'])}/></h5>
									</div>
									<div className="media d-flex">                
										<div className="align-self-center">
											<img width={ alert.iconSize } height={ alert.iconSize } src={require('../../assets/images/'+ alert.entity +'/'+ alert.image)}/>
										</div>                
										<div className="media-body text-right">                    
											<h4 className="text-bold-400">{!alert.value ? 0 : alert.value }</h4>
										</div>                
									</div>
									<div className="text-right">
										<h6 className="text-muted text-bold-400">{!alert.extraValue ? "" : alert.extraValue }</h6>
									</div>                
								</div> 
							</div>
						</div>
					</div>
				);
			})}
		  </div>
		</section>
	  : ''}
	  <div className="card">
		<div className="card-content">
		  <div className="card-body card-dashboard">
			<div className="row" style={{ marginBottom: '-20px' }}>
			  {Security.hasPermission('FORMULARIO_RECURRENCIA_CREAR') ?
				<StyledTooltip
				  title={intl.formatMessage({
					id: 'FormularioRecurrenciaGrid.button.label_add',
					defaultMessage: 'Agregar',
				  })}
				  arrow
				  placement="right"
				>
				  <div
					className="btn btn-primary box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
					style={{ height: 55 }}
					onClick={() => setRedirectTo(props.match.url + '/add')}
				  >
					<i className="ft-plus"></i>
				  </div>
				</StyledTooltip>
			  : ''}
			  <StyledTooltip
				title={intl.formatMessage({
				  id: 'FormularioRecurrenciaGrid.button.label_filtros',
				  defaultMessage: 'Filtros',
				})}
				arrow
				placement="right"
			  >
				<div
				  className="btn btn-grey-blue box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
				  onClick={() => setDropdownActive(!dropdownActive)}
				>
				  {dropdownActive ? <UpIcon /> : <ExpandMoreIcon />}
				</div>
			  </StyledTooltip>
			  {searchActive && (
				<div className="btn-dt-main round-icon">
				  <div
					className="text-center"
					style={{
					  height: '25px',
					  borderRadius: '3px',
					  display: 'flex',
					  justifyContent: 'center',
					  alignItems: 'center',
					  paddingLeft: '8px',
					  backgroundColor: '#5AAC43',
					  color: 'white',
					}}
				  >
					<div
					  className="text-center"
					  style={{
						width: '100%',
						fontSize: '12px',
						fontWeight: '500',
					  }}
					>
					  {formularioRecurrencias.length} de {paginationCount} resultados de busqueda
					</div>
					<div className="resultados-busqueda-notif">
					  <i
						className="las la-times la-xs cursor-pointer"
						onClick={handleFilterReset}
					  ></i>
					</div>
				  </div>
				</div>
			  )}
			</div>

			<FormularioRecurrenciaGridFilters
				columnsEnabled={columnsEnabled}
				resetFilterInputs={resetFilterInputs}
				setResetFilterInputs={setResetFilterInputs}
				filterQuery={filterQuery}
				filterQueryLast={filterQueryLast}
				setFilterQuery={setFilterQuery}
				setDropdownActive={setDropdownActive}
				dropdownActive={dropdownActive}
				searchActive={searchActive}
				setSearchActive={setSearchActive}
				filterEntidad={filterEntidad}
				onFilterChange={handleFilterChange}
				filterResetInputs={filterResetInputs}
				setFilterResetInputs={setFilterResetInputs}
				handleFilterChange={handleFilterChange}
				persisteFiltros={persisteFiltros}
				setPersisteFiltros={setPersisteFiltros}
			/>

			<TableContainer>
			  <Table>
				<TableHead>
				  <TableRow>
					<StyledTableCell
					  align="left"
					>
					  <FormattedMessage
						id="FormularioRecurrenciaGrid.render.table_column_CECO"
						defaultMessage="CECO"
					  />
					</StyledTableCell>

					<StyledTableCell align="left">

					</StyledTableCell>
					<StyledTableCell
					  align="left"
					  style={{ cursor: 'pointer' }}
					  onClick={() => handleSort('tipoFormulario')}
					>
					  <FormattedMessage
						id="FormularioRecurrenciaGrid.render.table_column_formulario"
						defaultMessage="Formulario"
					  />
					  <img
						className="ml-1"
						src={
						  sortQuery.tipoFormulario === ''
							? Sort
							: sortQuery.tipoFormulario === 'asc'
							? SortAsc
							: SortDesc
						}
						alt={'/'}
						style={{ height: '12px', width: '22px' }}
					  />
					</StyledTableCell>

					<StyledTableCell align="left">
					  <FormattedMessage
						id="FormularioRecurrenciaGrid.render.table_column_entidad"
						defaultMessage="Entidad"
					  />
					</StyledTableCell>

					<StyledTableCell
					  align="left"
					  style={{ cursor: 'pointer' }}
					  onClick={() => handleSort('fechaVencimiento')}
					>
					  <FormattedMessage
						id="FormularioRecurrenciaGrid.render.table_column_vencimiento"
						defaultMessage="Vencimiento"
					  />
					  <img
						className="ml-1"
						src={
						  sortQuery.fechaVencimiento === ''
							? Sort
							: sortQuery.fechaVencimiento === 'asc'
							? SortAsc
							: SortDesc
						}
						alt={'/'}
						style={{ height: '12px', width: '22px' }}
					  />
					</StyledTableCell>
					{columnsEnabled.transportadora ? 
						<StyledTableCell
						align="left"
						style={{ cursor: 'pointer' }}
						onClick={() => handleSort('transportadora')}
						>
						<FormattedMessage
							id="FormularioRecurrenciaGrid.render.table_column_transportadora"
							defaultMessage="Transportadora"
						/>
						</StyledTableCell>
					: null }
					<StyledTableCell align="left" style={{ cursor: 'pointer' }}>
					  <FormattedMessage
						id="FormularioRecurrenciaGrid.render.table_column_acciones"
						defaultMessage="Acciones"
					  />
					</StyledTableCell>
				  </TableRow>
				</TableHead>
				<TableBody>
					{loading && (
						<TableRow>
							<StyledTableCell colSpan={14} align="center">
							<CircularProgress />
							</StyledTableCell>
						</TableRow>
					)}
					{!loading &&
						(formularioRecurrencias.length > 0 ?
							formularioRecurrencias.map((formularioRecurrencia) => (
							<FormularioRecurrenciaGridRow
								key={'formularioRecurrenciasGridRow_' + formularioRecurrencia.id}
								baseUrl={props.match.url}
								formularioRecurrencia={formularioRecurrencia}
								columnsEnabled={columnsEnabled}
							/>
							))
						
						:
							<TableRow>
								<StyledTableCell colSpan={14} align="center">
								<FormattedMessage id="FormularioRecurrenciaGrid.rennder.no_data_table" defaultMessage="No se encontraron resultados..." />
								</StyledTableCell>
							</TableRow>
						)
					}
				</TableBody>
			  </Table>
			</TableContainer>
			<TablePagination
			  rowsPerPageOptions={rowsPerPage}
			  component="div"
			  count={paginationCount}
			  rowsPerPage={pagination.perPage}
			  page={pagination.page}
			  onPageChange={handlePageChange}
			  onRowsPerPageChange={handleRowsPerPageChange}
			  labelRowsPerPage="Mostrar"
			  labelDisplayedRows={({ from, to, count }) => `Mostrando ${from} a ${to} de ${count}`}
			/>
		  </div>
		</div>
	  </div>
	</>
  );
}

export default FormularioRecurrenciaGrid;